import React from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function CampaignModal({ isOpen, onClose, onConfirm }) {
    const navigate = useNavigate();

    if (!isOpen) return null;

    // Ensure functions for event handlers
    const handleClose = typeof onClose === "function" ? onClose : () => {};

    // When user clicks "Yes, use it", navigate to /WAMessage/WASendMessage/Index and (optionally) call onConfirm
    const handleConfirm = () => {
        if (typeof onConfirm === "function") {
            onConfirm();
        }
        navigate("/WAMessage/WASendMessage/Index");
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            <div className="bg-white rounded-2xl p-6 w-[400px] text-center shadow-lg">
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                        <FaCheck className="text-green-600 text-2xl" />
                    </div>
                </div>
                <h2 className="text-lg font-semibold mb-6">
                    Do you want to use this template in a campaign?
                </h2>
                <div className="flex justify-center gap-4">
                    <button
                        onClick={handleConfirm}
                        className="px-5 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                        type="button"
                    >
                        Yes, use it
                    </button>
                    <button
                        onClick={handleClose}
                        className="px-5 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                        type="button"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CampaignModal;